import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "../..";
import StorageItems from "../../../storage";
import { base64ToBlob } from "../../../utils/filesFuncs";
import { generateMessageReturn } from "../../../utils/messageFuncs";

const auth = new StorageItems().get("authToken");

class ApiCertificados extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  token;
  basePath = "certificados";
  constructor(data?: any) {
    super();
    this.token = auth?.authToken;

    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: this.token ? `Bearer ${this.token}` : "",
      },
    };

    if (data) {
      this.data = data;
      this.config.data = data;
    }
  }

  get = async (id: string) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/${id}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Pesquisa de certificados",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  list = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/list/`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Pesquisa de certificados",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  listPerConds = async (query: string) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/list-per-conds/${query}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Pesquisa de certificados",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  checkCertificate = async (file: any) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/check-dates`;
    this.config.method = "post";
    this.config.headers = {
      "Content-Type": "multipart/form-data",
      Authorization: this.token ? `Bearer ${this.token}` : "",
    };

    const formData = new FormData();
    if (file.startsWith("data:application/")) {
      const mimeType = file.match(/data:(.*);base64,/)[1]; // Extraia o tipo MIME
      const blob = base64ToBlob(file, mimeType); // Converte para Blob
      formData.append("file", blob, `${this.data.arquivo}.pfx`);
      formData.append("senha", this.data.senha);
    }

    this.config.data = formData;
    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Consulta de datas (certificado)",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  create = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/create`;
    this.config.method = "post";
    this.config.headers = {
      "Content-Type": "multipart/form-data",
      Authorization: this.token ? `Bearer ${this.token}` : "",
    };

    const formData = new FormData();

    if (this.data.file.startsWith("data:application/")) {
      const mimeType = this.data.file.match(/data:(.*);base64,/)[1];
      const blob = base64ToBlob(this.data.file, mimeType);
      formData.append("file", blob, `${this.data.arquivo}.pfx`);
      formData.append("arquivo", `${this.data.arquivo}.pfx`);
      formData.append("id_condominio_cond", this.data.id_condominio_cond);
      formData.append("data_emissao", this.data.data_emissao);
      formData.append("data_expiracao", this.data.data_expiracao);
      formData.append("senha", this.data.senha);
    }

    this.config.data = formData;
    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Consulta de datas (certificado)",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };
}

export default ApiCertificados;
